/**
 * Centralized form grid layout styles.
 * All dialog forms should use these for consistent field spacing.
 *
 * Usage with makeStyles:
 *   import { formGridClasses } from '../../styles/formGridStyles';
 *   const useStyles = makeStyles((theme) => ({
 *       ...formGridClasses(theme),
 *       // your additional styles
 *   }));
 *
 * Then in JSX:  className={classes.formGrid}  or  className={classes.gridGap2}
 */

const FIELD_MIN_WIDTH = '160px';
const FIELD_GAP = 2; // theme.spacing units → 12px

export const formGridClasses = (theme: any) => ({
    /** Primary form grid: auto-fill columns with consistent gap */
    formGrid: {
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fill, minmax(${FIELD_MIN_WIDTH}, 1fr))`,
        gridGap: theme.spacing(0, FIELD_GAP)
    },
    /** Grid gap: 0 vertical, 12px horizontal — for field rows */
    gridGap0_2: {
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fill, minmax(${FIELD_MIN_WIDTH}, 1fr))`,
        gridGap: theme.spacing(0, FIELD_GAP)
    },
    /** Grid gap: 12px all directions — for sections / larger spacing */
    gridGap2: {
        gridGap: theme.spacing(FIELD_GAP)
    },
    /** Grid gap: 6px all directions — for tighter layouts */
    gridGap1: {
        gridGap: theme.spacing(1)
    },
    /** Grid gap: 0 vertical, 6px horizontal — for compact field rows */
    gridGap0_1: {
        gridGap: theme.spacing(0, 1)
    },
    /** Grid gap: 6px vertical, 12px horizontal */
    gridGap1_2: {
        gridGap: theme.spacing(1, FIELD_GAP)
    },
    /** Bordered field group (for grouped sections inside a form) */
    gridBorder: {
        border: '1px solid',
        borderColor: theme.palette.grey[400],
        borderRadius: '4px',
        padding: theme.spacing(2, 1)
    }
});
